export var getFirstLoadContent = function getFirstLoadContent(state) {
  return state.content.firstLoadContent;
};
export var getValidateSchema = function getValidateSchema(state) {
  return state.content.validateSchema === undefined ? false : state.content.validateSchema;
};